<template>
  <div class="box">
    <swiper :options="swiperOptions" v-if="clientWidth > 768" :key="'ex-pc-' + swiperKey" ref="mySwiper"
      :auto-play="true" class="modulelist6_box swiper-no-swiping exhibition_box">
      <div v-if="clientWidth > 768" class="swiper-button-prev swiper-button-prev-ex-pc swiper-button1"
        slot="button-prev"></div>
      <div v-if="clientWidth > 768" class="swiper-button-next swiper-button-next-ex-pc swiper-button1"
        slot="button-next"></div>
      <swiper-slide v-for="(item, index) in list" :key="'ex-pc-slide-' + swiperKey + '-' + index" class="modulelist6">
        <div class="modulelist6_children" v-for="(val, cIndex) in item.children" :key="cIndex"
          :data-item="JSON.stringify(val)" style="cursor: pointer;">
          <div class="modulelist6_children_box">
            <div class="modulelist6_img">
              <img v-if="val.img" :src="Res_Url2026 + '/exhibition/' + val.img" alt="" />
              <img v-else :src="Res_Url2026 + '/exhibition/新品展示所有视频的封面.png'" alt="" />
            </div>
            <div class="line6"></div>
            <div class="modulelist6_content">
              <div class="modulelist6_left">
                <span v-html="val.title"></span>
                <span v-html="val.introduction.split('/n').join('<br />')"></span>
              </div>

              <div class="modulelist6_right" v-if="tab">
                <span>查看详情</span>
                <img :src="Res_Url + '/index/icon_next2.png'" alt="" />
              </div>
              <div class="modulelist6_right" v-else>
                <span>查看详情</span>
                <img :src="Res_Url + '/index/icon_next2.png'" alt="" />
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <swiper :options="swiperOption_m" v-else :key="'ex-m-' + swiperKey" ref="mySwiper" :auto-play="true"
      class="modulelist6_box exhibition_box">
      <div v-if="clientWidth < 768" class="swiper-button-prev swiper-button-prev-ex-m swiper-button1"
        slot="button-prev"></div>
      <div v-if="clientWidth < 768" class="swiper-button-next swiper-button-next-ex-m swiper-button1"
        slot="button-next"></div>
      <swiper-slide v-for="(item, index) in listm" :key="'ex-m-slide-' + swiperKey + '-' + index" class="modulelist6">
        <div class="modulelist6_children" v-for="(val, cIndex) in item.children" :key="cIndex"
          :data-item="JSON.stringify(val)" style="cursor: pointer;">
          <div class="modulelist6_children_box">
            <div class="modulelist6_img">
              <img v-if="val.img" :src="Res_Url2026 + '/exhibition/' + val.img" alt="" />
              <img v-else :src="Res_Url2026 + '/exhibition/新品展示所有视频的封面.png'" alt="" />
            </div>
            <div class="line6"></div>
            <div class="modulelist6_content">
              <div class="modulelist6_left">
                <span v-html="val.title"></span>
                <span v-html="val.introduction.split('/n').join('<br />')"></span>
              </div>
              <div class="modulelist6_right" v-if="tab">
                <span>查看详情</span>
                <img :src="Res_Url + '/index/icon_next2.png'" alt="" />
              </div>
              <div class="modulelist6_right" v-else>
                <span>查看详情</span>
                <img :src="Res_Url + '/index/icon_next2.png'" alt="" />
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <div class="intronumber">
      <div class="left"></div>
      <span v-if="clientWidth > 768">{{ currentIndex }}/{{ list.length }}</span>
      <span v-if="clientWidth <= 768">{{ currentIndex_m }}/{{ listm.length }}</span>
      <div class="right"></div>
    </div>
  </div>
</template>

<script>
import {
  Swiper as SwiperClass,
  Pagination,
  Mousewheel,
  Autoplay,
  Navigation,
} from "swiper/core";
import getAwesomeSwiper from "vue-awesome-swiper/dist/exporter";
import "swiper/swiper-bundle.min.css";
const { Swiper, SwiperSlide } = getAwesomeSwiper(SwiperClass);
SwiperClass.use([Pagination, Mousewheel, Autoplay, Navigation]);
import { Res_Url, Res_Url2026 } from "@/utils/ApiToken.js";
export default {
  props: {
    data: {
      type: Object,
      value: {},
    },
    tab: {
      type: Boolean,
      value: false,
    },
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  mounted() {
    this.currentData = this.data.industrial;
    this.$nextTick(() => {
      this.bindGlobalClickEvents();
    });
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleGlobalClick);
  },
  data() {
    const that = this;
    return {
      Res_Url: Res_Url,
      Res_Url2026: Res_Url2026,
      currentData: [],
      currentIndex: 1,
      currentIndex_m: 1,
      swiperKey: 0,
      swiperOptions: {
        initialSlide: 0,
        slidesPerView: 1,
        speed: 600,
        loop: false,
        spaceBetween: 0,
        autoplay: {
          delay: 4000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: ".swiper-button-next-ex-pc",
          prevEl: ".swiper-button-prev-ex-pc",
        },
        on: {
          init: (swiper) => {
            that.currentIndex = swiper.activeIndex + 1;
          },
          slideChange: (swiper) => {
            that.currentIndex = swiper.activeIndex + 1;
          },
        },
      },
      swiperOption_m: {
        initialSlide: 0,
        direction: "horizontal",
        autoplay: {
          delay: 500000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        loop: false,
        slidesPerView: 1,
        centeredSlides: false,
        spaceBetween: 40,
        navigation: {
          nextEl: ".swiper-button-next-ex-m",
          prevEl: ".swiper-button-prev-ex-m",
        },
        on: {
          init: (swiper) => {
            that.currentIndex_m = swiper.activeIndex + 1;
          },
          slideChange: (swiper) => {
            that.currentIndex_m = swiper.activeIndex + 1;
          },
        },
      },
    };
  },
  methods: {
    rebuildSwiper() {
      this.currentIndex = 1;
      this.currentIndex_m = 1;
      this.swiperKey += 1;
    },

    bindGlobalClickEvents() {
      document.addEventListener('click', this.handleGlobalClick);
    },

    handleGlobalClick(event) {
      const swiperContainer = document.querySelector('.exhibition_box');
      if (!swiperContainer || !swiperContainer.contains(event.target)) {
        return;
      }

      let target = event.target;
      let item = null;

      while (target && target !== swiperContainer) {
        if (target.dataset && target.dataset.item) {
          try {
            item = JSON.parse(target.dataset.item);
            break;
          } catch (e) {
            // 解析失败，继续查找
          }
        }
        target = target.parentElement;
      }

      if (item) {
        event.preventDefault();
        event.stopPropagation();
        this.toDetail(item);
      }
    },

    toDetail(item) {
      const obj = { event: "trk", ec: "news", ea: "readmore", el: "viewmore" };
      dataLayer.push(JSON.parse(JSON.stringify(obj)));
      let params = this.$route.query;
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.$store.commit("activeIndex", 3);
      this.$router.push({
        name: "Exhibition",
        query: {
          track: params.track ? params.track : "",
          utm_source: params.utm_source ? params.utm_source : "",
          utm_medium: params.utm_medium ? params.utm_medium : "",
          utm_campaign: params.utm_campaign ? params.utm_campaign : "",
          utm_content: params.utm_content ? params.utm_content : "",
          se_sr: params.se_sr ? params.se_sr : "",
          se_md: params.se_md ? params.se_md : "",
          se_ct: params.se_ct ? params.se_ct : "",
          tab: this.tab ? "true" : "false",
          title: item.title,
        },
      });
    },
  },
  computed: {
    clientWidth() {
      return this.$store.state.clientWidth;
    },
    list() {
      let arr = [];
      let i = Math.ceil(this.currentData.length / 6);
      for (let ind = 0; ind < i; ind++) {
        arr.push({
          children: [],
        });
      }
      let index = 0;
      this.currentData.map((sub) => {
        arr[index].children.push(sub);
        if (arr[index].children.length >= 6) {
          index += 1;
        }
      });
      let eles;
      if (arr.length === 1 && arr) {
        eles = document.querySelectorAll(".swiper-button1");
        if (eles && eles.length) {
          for (const n of eles) {
            n.style.display = "none";
          }
        }
      } else if (arr.length > 1) {
        eles = document.querySelectorAll(".swiper-button1");
        if (eles && eles.length) {
          for (const n of eles) {
            n.style.display = "flex";
          }
        }
      }
      return arr;
    },
    listm() {
      let arr = [];
      let i = Math.ceil(this.currentData.length / 4);
      for (let ind = 0; ind < i; ind++) {
        arr.push({
          children: [],
        });
      }
      let index = 0;
      this.currentData.map((sub) => {
        arr[index].children.push(sub);
        if (arr[index].children.length >= 4) {
          index += 1;
        }
      });
      return arr;
    },
  },
  watch: {
    tab() {
      const box = document.querySelector(".exhibition_box");
      if (box) box.style.opacity = 0;
      if (this.tab) {
        this.currentData = this.data.energy;
      } else {
        this.currentData = this.data.industrial;
      }
      this.rebuildSwiper();
      this.$nextTick(() => {
        setTimeout(() => {
          const nextBox = document.querySelector(".exhibition_box");
          if (nextBox) nextBox.style.opacity = 1;
        }, 50);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>
